(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hna-whatsapp-enquiry"] && !Shopify.designMode) return;
  try {
    (() => {
  function initWhatsApp() {
    const template = document.getElementById('hna-whatsapp-template');
    const stringsNode = document.getElementById('hna-whatsapp-strings');
    if (!template || !stringsNode) return;
    const strings = JSON.parse(stringsNode.textContent);
    const bulk = document.getElementById('HnaBulkContact');
    const form = bulk || document.getElementById('ContactForm');
    if (!form || form.querySelector('.hna-whatsapp-enquiry')) return;
    const fragment = template.content.cloneNode(true);
    const group = fragment.querySelector('.hna-whatsapp-enquiry');
    const link = group.querySelector('a');
    const status = group.querySelector('[role="status"]');
    const review = bulk && document.getElementById('hna-review');
    const destination = review || form;
    destination.append(fragment);
    link.addEventListener('click', event => {
      status.textContent = '';
      if (!form.reportValidity()) { event.preventDefault(); return; }
      let message;
      if (bulk) {
        const reviewText = document.getElementById('hna-review-text');
        if (!review || review.hidden || !reviewText || !reviewText.textContent.trim()) {
          event.preventDefault();
          status.textContent = strings.review;
          return;
        }
        message = strings.bulk + '\n\n' + reviewText.textContent.trim();
      } else {
        const lines = [];
        for (const field of form.querySelectorAll('input, textarea, select')) {
          if (!field.name || !field.name.startsWith('contact[') || field.disabled || field.type === 'hidden') continue;
          if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) continue;
          const value = field.value.trim();
          if (!value) continue;
          const label = field.labels && field.labels[0];
          const title = label ? label.textContent.trim() : field.name.slice(8, -1).replaceAll('_', ' ');
          lines.push(title + ': ' + value);
        }
        message = strings.intro + '\n\n' + lines.join('\n');
      }
      link.href = 'https://wa.me/916378090214?text=' + encodeURIComponent(message);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initWhatsApp, { once: true });
  else initWhatsApp();
  document.addEventListener('shopify:section:load', initWhatsApp);
})();
  } catch(e) { console.error(e); }
})();

})();
